/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import 'lazysizes';
import Vue from 'vue';
import { debounce } from 'lodash';
import Router from './router';

require('./bootstrap');

require('./components/glossary-component');
require('./components/news-component');
require('./components/multi-level-navigation-component');
require('./components/newsletter-signup-component');
require('./components/documents-component');
require('./components/poll-component');
require('./components/register-component');
require('./components/search-component');

// eslint-disable-next-line no-unused-vars
const App = new Vue({
    el: '#app',
    delimiters: ['${', '}'],

    data() {
        return {
            router: {
                currentSection: null,
                instance: null,
                prefetch: true,
            },
            showMobileMenu: false,
            showHeaderSearch: false,
            showMobileSearch: false,
        };
    },

    mounted() {
        window.addEventListener('scroll', () => {
            document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
        });
    },

    methods: {
        /**
         * Raised when the client window is resizing. Checks if the
         * application has switched to a mobile breakpoint and
         * act accordingly when a switch has indeed occurred.
         *
         * @return {Void}
         */
        onWindowResize: debounce(() => {
            EventBus.$emit('window-resize');
        }, 150),

        /**
         * Toggle the mobile menu
         */
        toggleMenu() {
            if (this.showMobileMenu) {
                this.showMobileMenu = false;
                const { body } = document;
                const scrollY = body.style.top;
                body.style.position = '';
                body.style.top = '';
                this.$refs.header.style.position = '';
                this.$refs.header.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
                return;
            }

            this.showMobileMenu = true;
            const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
            const { body } = document;
            body.style.position = 'fixed';
            body.style.top = `-${scrollY}`;
            this.$refs.header.style.position = 'fixed';
            this.$refs.header.style.top = '0';
        },

        /**
         * Toggle the header search field
         */
        toggleHeaderSearch() {
            this.showHeaderSearch = !this.showHeaderSearch;
        },

        /**
         * Toggle the mobile search field
         */
        toggleMobileSearch() {
            this.showMobileSearch = !this.showMobileSearch;
        },
    },

    beforeDestroy() {
        window.addEventListener('resize', this.onWindowResize);
    },
});
